import React, { createContext, useContext, useState, ReactNode } from 'react';

interface AIModuleContextType {
  theme: 'light' | 'dark';
  isEnabled: boolean;
  basePath: string;
  setTheme: (theme: 'light' | 'dark') => void;
  setEnabled: (enabled: boolean) => void;
}

const AIModuleContext = createContext<AIModuleContextType | undefined>(undefined);

interface AIModuleProviderProps {
  children: ReactNode;
  theme?: 'light' | 'dark';
  basePath?: string;
}

export const AIModuleProvider: React.FC<AIModuleProviderProps> = ({
  children,
  theme: initialTheme = 'dark',
  basePath = '/ai'
}) => {
  const [theme, setTheme] = useState<'light' | 'dark'>(initialTheme);
  const [isEnabled, setEnabled] = useState(true);

  const value = {
    theme,
    isEnabled,
    basePath,
    setTheme,
    setEnabled,
  };

  return (
    <AIModuleContext.Provider value={value}>
      {children}
    </AIModuleContext.Provider>
  );
};

export const useAIModule = () => {
  const context = useContext(AIModuleContext);
  if (context === undefined) {
    throw new Error('useAIModule must be used within an AIModuleProvider');
  }
  return context;
};